import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';

export const OfferFeeCatalogListItemSummary = ({ t, fee, idx, schemaIsEligibleForNegotiation }) => {
  return (
    <>
      <Grid item xs={12}>
        <span id={'IncomeFeeCard_summary_' + idx + '_name'}>
          <Typography fontWeight='bold' color='primary' fontSize='18px'>
            {fee ? fee.name + ': ' : ''}
          </Typography>
          {fee && fee.value && fee.value > 0 && !fee.isNotAnExpense && fee.showAmount
            ? fee.value + ' ' + fee.currencyCode
            : fee && fee.percent && fee.percent > 0
            ? fee.percent + ' %'
            : ''}
          {fee && fee.value && fee.value > 0 && fee.isNotAnExpense && fee.showAmount ? fee.value : ''}
        </span>
        <span>
          {schemaIsEligibleForNegotiation && fee && fee.approvalStatus && fee.approvalStatus !== ''
            ? '   ' + t('OfferEdit.FeeCatalog.NegotiationStatusName') + ': ' + t(`OfferEdit.FeeCatalog.${fee.approvalStatus}`)
            : ''}
        </span>
      </Grid>
    </>
  );
};

OfferFeeCatalogListItemSummary.propTypes = {
  t: PropTypes.func.isRequired,
  fee: PropTypes.object.isRequired,
  idx: PropTypes.number.isRequired,
  schemaIsEligibleForNegotiation: PropTypes.bool.isRequired
};

export default compose(withTranslation()(OfferFeeCatalogListItemSummary));
